<template>
    <div class="m-liveList">
        <div class="student-page">
            <div class="live-header">
                <div class="live-filter">
                    <el-select v-model="formSearch.status"
                               placeholder="选择直播状态"
                               size="small"
                               @change="query(1)"
                               clearable>
                        <el-option label="直播中" :value="1"></el-option>
                        <el-option label="预告" :value="2"></el-option>
                        <el-option label="结束" :value="3"></el-option>
                        <!--                    <el-option label="点播" :value="4"></el-option>-->
                        <el-option label="回放" :value="5"></el-option>
                    </el-select>

                    <el-select v-model="formSearch.topicsName"
                               placeholder="选择直播话题"
                               size="small"
                               @change="query(1)"
                               clearable>
                        <el-option v-for="item in topicList"
                                   :key="item"
                                   :label="item.topicName"
                                   :value="item.topicName">
                            <span style="float: left">{{ item.topicName }}</span>
                            <span style="float: right; color: #8492a6; font-size: 12px">（{{ item.count }}）</span>
                        </el-option>
                    </el-select>

                    <el-input
                        class="input-title"
                        v-model="formSearch.title"
                        :placeholder="$t('tip.name')"
                        size="small"
                        @keyup.enter.native="query(1)"
                        clearable>
                        <el-button slot="append" icon="el-icon-search" circle @click="query(1)"></el-button>
                    </el-input>

                </div>

            </div>

            <room-list
                class="live-list"
                :data="liveRooms"
                @live-enter="enterLive"
            ></room-list>

            <div class="pagination-bar">
                <el-pagination :current-page="currentPage"
                               :page-size="pageSize"
                               :total="pageTotal"
                               @current-change="handleCurrentChange"
                               layout="total, prev, pager, next, jumper" >
                </el-pagination>
            </div>
        </div>

        <transition enter-active-class="animated zoomIn"
                    leave-active-class="animated zoomOut">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
/**
 * todo:
 * 2、密码对接接口
 */
import RoomList from "./Components/RoomList";
import api from "@/api";
import {aesEncrypt} from "@/utils/md5";

export default {
    components: {
        RoomList
    },

    data() {
        return {
            formSearch: {
                status: '',
                topicsName: '',
                title: ''
            },
            liveRooms: [],
            topicList: [],

            currentPage: 1,
            pageTotal: 0,
            pageSize: 20,
        }
    },

    computed: {

    },

    mounted() {
        this.getTopicList()

        this.query()
    },

    methods: {
        async getTopicList() {
            let res = await this.$api.getLiveTopicListUsed()
            let data = res.package
            this.topicList = data
        },

        async query(num) {
            if (num) {
                this.currentPage = num
            }

            let queryData = {
                ...this.formSearch,
                PageNO: this.currentPage,
                Limit: this.pageSize,
            }

            let res = await this.$api.queryLiveRooms(queryData)
            let data = res.package

            this.pageTotal = res.total
            this.liveRooms = data
            //this.liveRooms = [...data,...data,...data,...data]
        },

        enterLive(data) {
            let {id, needPassword} = data

            if (needPassword) {
                this.$prompt(this.$t('live.inputRoomPwd'), this.$t('m.tip'), {

                }).then(({ value }) => {
                    api.getLiveViewUrl(id, {password: value}).then(res => {
                        let encryptedPassword = aesEncrypt(value, 'live')
                        this.$router.push({name: 'liveRoomNew', params: {id, password: encryptedPassword}})
                    })
                })
            } else {
                this.$router.push({name: 'liveRoomNew', params: {id, password: 0}})
            }

            //this.$router.push({name: 'liveRoomNew', params: {id}})
        },

        handleCurrentChange(num) {
            this.query(num);
        },
    },
}
</script>

<style scoped lang="scss">
.m-liveList {
    height: 100%;
    overflow-y: auto;

    .student-page {
        padding-bottom: 10px;
    }

    .live-header {
        padding: 15px;
    }

    .live-filter {
        display: flex;
        padding-top: 10px;

        .input-title {
            width: 220px;
            margin-left: 15px;
        }

        .el-select + .el-select {
            margin-left: 15px;
        }
    }

    .live-list {
        min-height: 480px;
    }

    .pagination-bar .el-pagination {
        padding-bottom: 16px;
        text-align: center;
    }
}
</style>
